import type { SVGProps } from 'react';

type Props = { width?: number; height?: number; color?: string } & SVGProps<SVGSVGElement>;

export const SVG = (props: Props) => (
  <svg
    width={props.width}
    height={props.height}
    enableBackground='new 0 0 800 800'
    viewBox='0 0 800 800'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g>
      <path
        fill={props?.color || '#03D6A1'}
        d='M573.379,706.453L401.62,755.427c-128.219,36.765-260.741-41.563-296.377-174.934L58.175,402.031
		C22.892,268.521,98.186,130.705,226.404,93.94l171.758-49.396C526.381,7.849,659.256,86.178,694.541,219.548l47.278,178.743
		c35.283,133.37-39.94,271.326-168.159,308.021'
      />
      <path
        fill='#FFFFFF'
        d='M450.945,548.809c-6.851,2.686-13.866,4.819-21.053,6.399c-7.186,1.581-14.451,2.592-21.795,3.028
		c-7.346,0.437-14.68,0.297-22.002-0.42s-14.544-2.002-21.665-3.856c-4.123-1.208-8.19-2.578-12.204-4.11
		c-4.013-1.532-7.96-3.221-11.839-5.068c-3.879-1.846-7.678-3.844-11.398-5.993c-3.72-2.148-7.348-4.442-10.885-6.881
		s-6.973-5.014-10.305-7.725c-3.331-2.712-6.55-5.552-9.657-8.52c-3.105-2.97-6.089-6.056-8.949-9.261
		c-2.86-3.207-5.587-6.521-8.184-9.943c-2.597-3.424-5.052-6.944-7.368-10.563c-2.315-3.619-4.483-7.324-6.504-11.115
		c-2.02-3.792-3.887-7.657-5.6-11.598c-1.712-3.939-3.265-7.941-4.66-12.005c-1.394-4.063-2.624-8.177-3.689-12.338
		c-1.067-4.162-1.965-8.36-2.697-12.593c-0.732-4.233-1.295-8.489-1.688-12.767c-0.393-4.278-0.615-8.565-0.667-12.861
		c-0.103-5.19,0.049-10.373,0.456-15.548c0.408-5.175,1.069-10.318,1.983-15.428c0.915-5.11,2.078-10.163,3.49-15.158
		c1.413-4.995,3.067-9.909,4.964-14.741c1.896-4.832,4.027-9.559,6.389-14.182c2.363-4.622,4.947-9.118,7.753-13.484
		c2.805-4.369,5.818-8.587,9.041-12.658c3.221-4.071,6.636-7.973,10.242-11.707c3.358-3.507,6.88-6.841,10.566-10.001
		c3.687-3.16,7.519-6.132,11.497-8.916c3.978-2.784,8.083-5.366,12.315-7.746c4.232-2.38,8.571-4.547,13.016-6.501
		c4.445-1.953,8.975-3.685,13.59-5.193c4.615-1.508,9.294-2.787,14.034-3.835c4.741-1.049,9.522-1.862,14.343-2.441
		c4.821-0.579,9.658-0.92,14.513-1.023l1.411,0.001c71.059,0.775,116.152,56.452,116.576,57.229c0.712,0.931,1.51,1.779,2.395,2.548
		c0.885,0.768,1.838,1.439,2.858,2.014c1.021,0.575,2.09,1.041,3.206,1.398c1.115,0.357,2.256,0.598,3.421,0.724
		s2.33,0.133,3.497,0.021c1.166-0.111,2.309-0.339,3.429-0.683s2.192-0.797,3.221-1.359c1.027-0.562,1.989-1.222,2.883-1.979
		c0.903-0.789,1.723-1.654,2.461-2.597c0.74-0.944,1.384-1.948,1.932-3.014c0.548-1.065,0.991-2.172,1.33-3.322
		c0.338-1.149,0.565-2.32,0.684-3.513c0.116-1.191,0.121-2.385,0.012-3.578c-0.108-1.193-0.329-2.366-0.66-3.518
		c-0.33-1.151-0.767-2.262-1.307-3.331c-0.543-1.068-1.179-2.077-1.91-3.026c-2.259-2.893-55.606-69.86-143.673-70.566
		c-6.09,0.048-12.162,0.4-18.216,1.057c-6.054,0.657-12.061,1.614-18.02,2.872c-5.958,1.258-11.839,2.812-17.642,4.659
		c-5.803,1.848-11.499,3.98-17.088,6.399c-5.589,2.418-11.043,5.11-16.363,8.075c-5.32,2.964-10.478,6.188-15.475,9.669
		c-4.996,3.481-9.807,7.205-14.43,11.167c-4.624,3.963-9.038,8.149-13.242,12.555c-2.924,3.07-5.746,6.23-8.466,9.481
		c-2.721,3.25-5.335,6.585-7.844,10.002c-2.508,3.418-4.904,6.912-7.19,10.483c-2.284,3.57-4.453,7.21-6.506,10.92
		c-2.052,3.709-3.984,7.48-5.795,11.313c-1.812,3.833-3.499,7.719-5.063,11.659c-1.563,3.941-2.999,7.927-4.307,11.959
		c-1.309,4.032-2.487,8.103-3.535,12.209c-1.048,4.108-1.965,8.245-2.749,12.411c-0.785,4.166-1.436,8.353-1.952,12.56
		c-0.517,4.208-0.899,8.428-1.146,12.66s-0.358,8.468-0.335,12.707c0.023,4.239,0.183,8.473,0.477,12.702
		c0.293,4.229,0.723,8.444,1.286,12.646c0.563,4.201,1.26,8.382,2.091,12.539c0.83,4.156,1.792,8.283,2.886,12.379
		c1.094,4.096,2.317,8.151,3.67,12.17c1.353,4.018,2.833,7.987,4.439,11.91c1.606,3.923,3.337,7.791,5.191,11.603
		c1.854,3.813,3.827,7.563,5.92,11.249s4.302,7.302,6.626,10.848c2.324,3.545,4.759,7.013,7.305,10.401
		c2.546,3.39,5.198,6.694,7.955,9.915c2.756,3.22,5.614,6.35,8.57,9.387c2.957,3.038,6.008,5.979,9.153,8.82
		c3.145,2.844,6.377,5.583,9.696,8.219c3.32,2.638,6.721,5.165,10.202,7.582c3.481,2.42,7.036,4.726,10.664,6.918
		c3.629,2.192,7.324,4.266,11.085,6.222c3.761,1.955,7.581,3.79,11.458,5.502c3.878,1.712,7.807,3.298,11.787,4.759
		c3.98,1.461,8.002,2.793,12.067,3.997c14.248,3.928,28.76,5.88,43.539,5.858c10.989-0.031,21.887-1.056,32.689-3.071
		c10.804-2.015,21.336-4.99,31.597-8.927c54.406-20.676,107.543-75.153,105.85-138.097c-12.382,9.317-25.317,17.784-38.813,25.403
		c-10.653,34.577-44.103,64.851-78.962,78.117'
      />
      <path
        fill='#FFFFFF'
        d='M584.598,357.081c-11.738,12.608-24.51,24.064-38.316,34.366c-2.984-2.757-6.087-5.373-9.311-7.845
		c-3.224-2.473-6.554-4.793-9.99-6.961c-3.435-2.167-6.964-4.172-10.584-6.016c-3.62-1.844-7.317-3.519-11.09-5.023
		c-3.773-1.504-7.608-2.833-11.504-3.985c-3.896-1.153-7.837-2.126-11.82-2.917c-3.984-0.792-7.997-1.399-12.038-1.823
		c-4.039-0.423-8.091-0.661-12.154-0.713c-22.298,0-39.375,6.069-50.735,18.065c-2.223,2.369-4.19,4.931-5.906,7.689
		c-1.717,2.757-3.146,5.655-4.291,8.695s-1.98,6.161-2.509,9.364c-0.529,3.206-0.74,6.431-0.632,9.675
		c0,24.981,17.571,52.15,64.849,53.209c6.525-0.065,13.018-0.544,19.48-1.435c6.461-0.89,12.842-2.186,19.141-3.89
		c6.296-1.702,12.46-3.796,18.491-6.282c6.031-2.487,11.881-5.346,17.548-8.577c11.222-5.946,21.9-12.744,32.037-20.394
		c16.39-12.032,31.492-25.511,45.303-40.434c0.794-0.898,1.494-1.864,2.103-2.896c0.61-1.033,1.115-2.113,1.517-3.242
		c0.403-1.129,0.694-2.285,0.876-3.47c0.183-1.184,0.251-2.375,0.206-3.573c-0.047-1.198-0.204-2.381-0.477-3.548
		c-0.271-1.167-0.65-2.298-1.137-3.394c-0.487-1.095-1.073-2.134-1.759-3.117c-0.686-0.982-1.458-1.892-2.316-2.729
		c-0.836-0.821-1.745-1.55-2.729-2.185c-0.984-0.635-2.022-1.164-3.115-1.585c-1.093-0.423-2.216-0.729-3.371-0.922
		c-1.155-0.192-2.318-0.265-3.488-0.218c-1.171,0.046-2.324,0.211-3.461,0.494s-2.233,0.677-3.289,1.185
		c-1.056,0.507-2.049,1.116-2.979,1.827c-0.931,0.71-1.78,1.508-2.548,2.393 M459.344,426.236c-13.689,0-30.062-3.529-30.274-16.937
		c-0.139-1.706,0.069-3.368,0.621-4.988c0.552-1.619,1.403-3.062,2.556-4.327c2.469-2.61,9.173-7.056,25.544-7.056
		c5.037,0.139,10.036,0.644,14.999,1.519c4.963,0.873,9.834,2.105,14.616,3.695c4.78,1.59,9.419,3.521,13.917,5.793
		c4.496,2.271,8.805,4.858,12.922,7.765c-8.399,4.678-17.245,8.249-26.541,10.709C478.411,424.87,468.956,426.146,459.344,426.236'
      />
    </g>
  </svg>
);

export default SVG;
